<div class="layout-row layout-align-start-center">

  <app-bringoz-state-link [state]="'agent.agent-profile'"
                          [permission]="'drivers.get'"
                          [params]="{id: agentId || agent?.id || agentReference?.id}"
                          [text]="agentName || (agent?.user | userName) || (agentReference | userName)"
                          (linkClick)="linkClick.emit()">
  </app-bringoz-state-link>

</div>



